module.exports = __webpack_public_path__ + "static/media/hand-rock.38caa39f.svg";